import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WatchLaterIcon(props: IconProps) {
    return <Icon {...props} iconKey={"watch_later"}/>
}
